import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import logo from "./assets/image/txc-logo.svg";
import { demoList, advList as advListDefault } from './TaskBarJson';

export interface TaskParams {
  label: string,
  key: string,
  value: boolean,
}

interface TaskBarProps {
  taskList?: Array<TaskParams>
  language?: string
}

export default function TaskBar(props:TaskBarProps):React.ReactElement{
  const {
    taskList = [],
    language
  } = props;
  const { t } = useTranslation();
  const [advList, setAdvList] = useState(advListDefault);

  useEffect(() => {
    const newDdvList = [...advListDefault];
    newDdvList[1].url = language === 'zh-CN' ? 'https://zhiliao.qq.com/' : 'https://www.tencentcloud.com/document/product/1047/41676?lang=en&pg=';
    setAdvList(newDdvList);
  },[language])
  return (<div className='task-bar'>
    <header>
      <h1 className="txc-logo"><img src={logo} alt="" />{t('Tencent Cloud')}</h1>
      <h1 className="im-logo">{t('Chat')}</h1>
    </header>
    <main>
      <ul className="list task-list">
        <h2 className="list-title">{t('Recommended Demo Features')}</h2>
        {
          taskList.map((item, index)=> (
            <li className={`list-item ${item.value ? 'completed' : ''}`} key={`task-${index}`} id={`task-${index}`}>
              <label htmlFor={`task-${index}`}>{t(item.label)}</label>
              <span>{t(item.value ? 'Completed' : 'Not tried yet')}</span>
            </li>
          ))
        }
      </ul>
      <ul className="list demo-list">
        <h2 className="list-title">{t('Get Started - Run a Demo')}</h2>
        {
          demoList.map((item, index)=> (
            <li className="list-item" key={`demo-${index}`}>
              <i className='step-circle'>{index+1}</i>
              <a href={item.url} target='_blank' rel="noreferrer">{item.label}</a>
            </li>
          ))
        }
      </ul>
    </main>
    <footer>
      <ul className="adv-list">
          {
            advList.map((item, index)=>(
              <li className="adv-list-item" key={`adv-${item.url}`}>
                <a id={`task-${index}`} href={item.url} target='_blank' rel="noreferrer">
                  <label htmlFor={`task-${index}`}>{t(item.label)}</label>
                  <span>{t(item.btnText)}</span>
                </a>
              </li>
            ))
          }
        </ul>
    </footer>
  </div> );
}
